const KEY = "mindfold-lab.v1.deviceKey";

function randomHex(bytes = 32): string {
  const arr = new Uint8Array(bytes);
  crypto.getRandomValues(arr);
  return Array.from(arr, (b) => b.toString(16).padStart(2, "0")).join("");
}

export function getDeviceKey(): string {
  let key = localStorage.getItem(KEY);
  if (!key) {
    key = `device_${randomHex(32)}`;
    localStorage.setItem(KEY, key);
  }
  return key;
}

export function resetDeviceKey(): string {
  const key = `device_${randomHex(32)}`;
  localStorage.setItem(KEY, key);
  return key;
}
